import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class WatchTowerForm extends Component {

  componentDidMount() {
    const { plugin, onChange } = this.props
    onChange({
      setting: {
        notiType: this.props.data.setting.notiType||'comment',
        watchTowerId: this.props.data.setting.watchTowerId||'0'
      },
      validated: plugin.active
    })
  }

  @autobind
  handleChangeWatchTowerId(value) {
    const { data, onChange } = this.props
    onChange(update(data, {
      setting: {
        watchTowerId: {
          $set: value
        }
      },
      validated: {
        $set: value > 0
      }
    }))
  }

  @autobind
  handleChangeNotiType(item) {
    const { data, onChange } = this.props
    onChange(update(data, {
      setting: {
        notiType: {
          $set: item.value
        }
      },
      validated: {
        $set: this.props.data.setting.watchTowerId > 0
      }
    }))
  }

  render() {
    const { plugin, data } = this.props;

    return (
      <div className="desc_plugin122">
        <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

        <div className="info_plugin">
          <div className="item_set item_sub">
            <TSelectForm className="opt_set opt_plugin1" items={[
              { label:'댓글', value:'comment' },
              { label:'방명록', value:'guestbook' },
              { label:'댓글+방명록', value:'comment+guestbook' },
            ]} selected={data.setting.notiType} onSelect={this.handleChangeNotiType} />
            이 작성 되면
            <TInputForm type="number" className="tf_set tf_set78" onChange={this.handleChangeWatchTowerId} value={data.setting.watchTowerId} />
            ID 로 로 알림을 보냅니다.
          </div>
        </div>
        {this.props.saveButton()}
      </div>
    )
  }
}

WatchTowerForm.propTypes = {
  plugin: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default WatchTowerForm
